import { VueModule } from '@Foundation/utilities';
import articleHeader from './code/Scripts/components/article-header.vue';

export default VueModule({
  components: {
    articleHeader,
  },
});
